(() => {
  const initHome = (root) => {
    if (!root || root.dataset.giwigiReady === 'true') return;
    root.dataset.giwigiReady = 'true';
    document.body.classList.add('g-home-active');

    const gate = root.querySelector('[data-g-age]');
    const enter = root.querySelector('[data-g-enter]');
    if (gate) {
      if (window.localStorage.getItem('giwigi-age-confirmed') === 'yes' || window.Shopify?.designMode) {
        gate.classList.add('is-hidden');
      }
      enter?.addEventListener('click', () => {
        window.localStorage.setItem('giwigi-age-confirmed', 'yes');
        gate.classList.add('is-leaving');
        window.setTimeout(() => gate.classList.add('is-hidden'), 620);
      });
    }

    const revealItems = root.querySelectorAll('.g-reveal');
    if ('IntersectionObserver' in window && root.classList.contains('g-animate')) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      revealItems.forEach((item) => observer.observe(item));
    } else {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    }

    const hero = root.querySelector('[data-g-hero]');
    hero?.addEventListener('pointermove', (event) => {
      const bounds = hero.getBoundingClientRect();
      const x = (event.clientX - bounds.left) / bounds.width - 0.5;
      const y = (event.clientY - bounds.top) / bounds.height - 0.5;
      hero.style.setProperty('--g-px', x.toFixed(3));
      hero.style.setProperty('--g-py', y.toFixed(3));
    });

    const form = root.querySelector('[data-g-zip-form]');
    const input = root.querySelector('[data-g-zip]');
    const result = root.querySelector('[data-g-zip-result]');
    const activeZips = new Set((root.dataset.activeZips || '').match(/\b\d{5}\b/g) || []);
    const localUrl = root.dataset.localUrl || '/collections/houston-same-day-drop-offs-giwigi-delivery';

    input?.addEventListener('input', () => {
      input.value = input.value.replace(/\D/g, '').slice(0, 5);
      result?.classList.remove('is-active');
      if (result) result.textContent = '';
    });

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      const zip = (input?.value || '').replace(/\D/g, '').slice(0, 5);
      if (input) input.value = zip;
      if (!result) return;
      result.textContent = '';
      result.classList.add('is-active');

      const title = document.createElement('strong');
      const copy = document.createElement('span');
      const link = document.createElement('a');
      if (activeZips.has(zip)) {
        title.textContent = 'You’re in the zone.';
        copy.textContent = 'Same-day drop-off is available Monday–Friday.';
        link.textContent = 'Shop what’s available ↗';
        link.href = localUrl;
      } else {
        title.textContent = zip ? `We’re not in ${zip} yet.` : 'Enter a five-digit ZIP.';
        copy.textContent = 'Nationwide shipping may still be available where eligible.';
        link.textContent = 'Shop eligible products ↗';
        link.href = '/collections/all';
      }
      result.append(title, copy, link);
    });
  };

  const initAll = () => document.querySelectorAll('[data-giwigi-home]').forEach(initHome);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
